import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Activity, ArrowLeft, User, Mail, Calendar, LogOut } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Profile = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await axios.get(`${API}/auth/me`, {
          withCredentials: true
        });
        setUser(response.data);
      } catch (error) {
        console.error('Error fetching user:', error);
        navigate('/login');
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [navigate]);

  const handleLogout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, {
        withCredentials: true
      });
      navigate('/login');
    } catch (error) {
      console.error('Error logging out:', error);
      // Still navigate to login even if logout fails
      navigate('/login');
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="new-dashboard-container" data-testid="profile-page">
      {/* Header */}
      <div className="new-dashboard-header">
        <div className="header-content">
          <div className="mode-tabs">
            <button 
              className="nav-link" 
              onClick={() => navigate('/dashboard')}
              data-testid="back-to-dashboard"
              style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
            >
              <ArrowLeft size={18} /> Back to Dashboard
            </button>
          </div>
        </div>
      </div>

      <div className="new-dashboard-content">
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <h2 className="section-title" data-testid="page-title">
            <User size={32} /> My Profile
          </h2>

          {/* Profile Card */}
          <div className="profile-info-card">
            <div className="profile-header">
              <div className="profile-avatar">
                {user?.picture ? (
                  <img src={user.picture} alt={user.name} className="avatar-image" />
                ) : (
                  <User size={48} color="#0277bd" />
                )}
              </div>
              <div className="profile-details">
                <h3 className="profile-name">{user?.name}</h3>
                <p className="profile-email">
                  <Mail size={16} /> {user?.email}
                </p>
                {user?.created_at && (
                  <p className="profile-joined">
                    <Calendar size={16} /> Joined {new Date(user.created_at).toLocaleDateString()}
                  </p>
                )}
              </div>
            </div>

            <div className="profile-actions">
              <button 
                className="logout-btn"
                onClick={handleLogout}
                data-testid="logout-btn"
              >
                <LogOut size={20} /> Sign Out
              </button>
            </div>
          </div>

          {/* Additional Info */}
          <div style={{ 
            background: 'white', 
            borderRadius: '16px', 
            padding: '2rem', 
            marginTop: '2rem',
            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.08)'
          }}>
            <h4 style={{ color: '#0277bd', marginBottom: '1rem', fontSize: '1.25rem' }}>
              Account Information
            </h4>
            <div style={{ color: '#78909c', lineHeight: '1.8' }}>
              <p><strong>User ID:</strong> {user?.user_id}</p>
              <p><strong>Account Status:</strong> Active</p>
              <p><strong>Authentication:</strong> Google OAuth</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
